import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Auth
import Login from './components/Auth/Login';
import Signup from './components/Auth/Signup';
import VerifyEmail from './components/Auth/VerifyEmail';
import ForgotPassword from './components/Auth/ForgotPassword';

// Layout & Chat
import Layout from './components/Layout/Layout';
import ChatArea from './components/Chat/ChatArea';

// Pages
import Pricing from './pages/Pricing';
import FAQ from './pages/FAQ';
import HowItWorks from './pages/HowItWorks';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Contact from './pages/Contact';
import Extension from './pages/Extension';
import UserDashboard from './components/Dashboard/UserDashboard';
import SavedReplies from './components/Dashboard/SavedReplies';

// Admin
import AdminLayout from './components/Admin/AdminLayout';
import AdminDashboard from './components/Admin/AdminDashboard';
import UserManagement from './components/Admin/UserManagement';
import SubscriptionAnalytics from './components/Admin/SubscriptionAnalytics';
import EmailSubscribers from './components/Admin/EmailSubscribers';
import BlogManager from './components/Admin/BlogManager';
import Messages from './components/Admin/Messages';
import WebSource from './components/Admin/WebSource';
import CreditBuySource from './components/Admin/CreditBuySource';

// Blog
import BlogList from './components/Blog/BlogList';
import BlogPost from './components/Blog/BlogPost';

// Guards
import ProtectedRoute from './components/common/ProtectedRoute';
import AdminRoute from './components/common/AdminRoute';

import useVisitorTracking from './hooks/useVisitorTracking';
import './App.css';

function VisitorTracker() {
  useVisitorTracking();
  return null;
}

function ChatPage() {
  const [currentChatId, setCurrentChatId] = useState(null);

  return (
    <Layout
      currentChatId={currentChatId}
      onSelectChat={(id) => setCurrentChatId(id)}
      onNewChat={() => setCurrentChatId(null)}
    >
      <ChatArea
        chatId={currentChatId}
        onChatCreated={(id) => setCurrentChatId(id)}
      />
    </Layout>
  );
}

export default function App() {
  return (
    <>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: '#1e293b',
            color: '#f1f5f9',
            border: '1px solid #334155',
            borderRadius: '10px',
            fontSize: '14px'
          }
        }}
      />

      <VisitorTracker />
      <Routes>
        {/* Chat is the landing page */}
        <Route path="/" element={<ChatPage />} />
        <Route path="/chat" element={<ChatPage />} />

        {/* Auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/verify" element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* Info Pages */}
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/extension" element={<Extension />} />

        {/* Blog */}
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />

        {/* Protected */}
        <Route path="/dashboard" element={<ProtectedRoute><UserDashboard /></ProtectedRoute>} />
        <Route path="/saved-replies" element={<ProtectedRoute><SavedReplies /></ProtectedRoute>} />

        {/* Admin */}
        <Route path="/admin" element={<AdminRoute><AdminLayout><AdminDashboard /></AdminLayout></AdminRoute>} />
        <Route path="/admin/users" element={<AdminRoute><AdminLayout><UserManagement /></AdminLayout></AdminRoute>} />
        <Route path="/admin/subscriptions" element={<AdminRoute><AdminLayout><SubscriptionAnalytics /></AdminLayout></AdminRoute>} />
        <Route path="/admin/web-source" element={<AdminRoute><AdminLayout><WebSource /></AdminLayout></AdminRoute>} />
        <Route path="/admin/credit-source" element={<AdminRoute><AdminLayout><CreditBuySource /></AdminLayout></AdminRoute>} />
        <Route path="/admin/messages" element={<AdminRoute><AdminLayout><Messages /></AdminLayout></AdminRoute>} />
        <Route path="/admin/email-subscribers" element={<AdminRoute><AdminLayout><EmailSubscribers /></AdminLayout></AdminRoute>} />
        <Route path="/admin/blog" element={<AdminRoute><AdminLayout><BlogManager /></AdminLayout></AdminRoute>} />
      </Routes>
    </>
  );
}
